import styled from 'styled-components'

export const Container = styled.section`
	margin: 10px;
	padding: 10px;
	min-height: 500px;
`

export const Root = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 10px;

	@media (max-width: 1641px) {
		display: flex;
		flex-direction: column;
	}
`

export const SettingsSectionRoot = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	margin: 10px;
	border: 1px solid #dcdada;
	border-radius: 5px;
	box-shadow: 0 0 4px #0000001a;
	padding: 0;
`

export const SettingsSectionCaption = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	border-bottom: 1px solid #dcdada;
	border-radius: 5px 5px 0 0;
	padding: 5px 10px;
	width: 100%;
	font-weight: 700;
`

export const SettingsSectionBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 10px;
	width: 100%;
`
